// extracted by mini-css-extract-plugin
export default {"productGallery":"JG-z","inQuickShop":"KG-z"};